import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { RouterModule } from '@angular/router';
import { ManagedLinkDirective } from './managed-link/managed-link.directive';
import { AppIconComponent } from './app-icon/app-icon.component';
import { GtagEventDirective } from './gtag-event/gtag-event.directive';
import { ModalComponent } from './modal/modal.component';
import { HiPhotoComponent } from './hi-photo/hi-photo.component';
import { UserPhotoComponent } from './user-photo/user-photo.component';
import { ArrowIconComponent } from './arrow-icon/arrow-icon.component';
import { LoadingComponent } from './loading/loading.component';
import { SwitchableImageComponent } from './switchable-image/switchable-image.component';
import { VencimientoClaveComponent } from './vencimiento-clave/vencimiento-clave.component';
import { Voxintar } from './voxintar';
import { CountdownTimerComponent } from './countdown-timer/countdown-timer.component';
import { BlockCopyPasteDirective } from './block-copy-paste/block-copy-paste.directive';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { BreakpointService } from './breakpointService';

@NgModule({
	declarations: [
		BreadcrumbComponent,
		ManagedLinkDirective,
		AppIconComponent,
		GtagEventDirective,
		ModalComponent,
		HiPhotoComponent,
		UserPhotoComponent,
		ArrowIconComponent,
		LoadingComponent,
		SwitchableImageComponent,
		VencimientoClaveComponent,
		CountdownTimerComponent,
		BlockCopyPasteDirective,
		DatepickerComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		NgbModule
	],
	providers: [
		Voxintar,
		BreakpointService
	],
	exports: [
		BreadcrumbComponent,
		ManagedLinkDirective,
		AppIconComponent,
		GtagEventDirective,
		ModalComponent,
		HiPhotoComponent,
		UserPhotoComponent,
		ArrowIconComponent,
		LoadingComponent,
		SwitchableImageComponent,
		VencimientoClaveComponent,
		CountdownTimerComponent,
		BlockCopyPasteDirective,
		DatepickerComponent
	]
})
export class SharedModule {
}
